(function () {
  'use strict';

  angular.module('app').component('paymentGatewayList', paymentGatewayList());

  function paymentGatewayList() {
    return {
      bindings: {
        paymentGateways: '=',
        onShowPaymentGateway: '&',
        paymentMethods: '<',
      },
      controller: PaymentGatewayListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-gateways/payment-gateway-list/payment-gateway-list.component.html',
    };
  }

  PaymentGatewayListComponent.$inject = ['UtilService', 'AbilityService', 'PaymentGatewayService'];

  function PaymentGatewayListComponent(UtilService, AbilityService, PaymentGatewayService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_company_both'),
      canUpdate: AbilityService.can('update_company_both'),
    };

    vm.$onInit = function () {
      setPaymentGateways();
    };

    // public methods
    // -----------------------
    vm.showPaymentGateway = function (paymentGateway, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowPaymentGateway({ item: paymentGateway, mode: mode });
    };

    vm.setDefaultPaymentGateway = function (paymentGateway) {
      var successCallback = function () {
        vm.paymentGateways.forEach(function (item) {
          if (item.id !== paymentGateway.id) {
            item.is_default = false;
          }
        });
      };

      PaymentGatewayService.setDefaultPaymentGateway(paymentGateway, successCallback);
    };

    // private methods
    // -----------------------
    function setPaymentGateways() {
      if (vm.paymentMethods.length === 0) return;

      vm.paymentGateways.map((paymentGateway) => {
        paymentGateway.paymentMethodName = vm.paymentMethods.find(
          (paymentMethod) => paymentMethod.id === paymentGateway.payment_method_id
        ).name;
      });
    }
  }
})();
